<mat-card>
    <mat-card-title class="font-weight-bold caption-color">Competition Detail CSA Rate</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content class="pt-2">
        <table class="table ">
            <thead>
                <tr>
                    <th>SrNo.</th>
                    <th>Counter Desc</th>
                    <th>Rate</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of _SPRACompetitionCsaRate; let i = index;">

                    <td>
                        {{i+1}}
                    </td>
                    <td>
                       {{item.CounterDesc}}
                    </td>
                    <td>
                        <input type="number" name="txtRate" [(ngModel)]="item.Rate" class="form-control">
                    </td>
                    
                </tr>
            </tbody>
        </table>

        <div class="card-footer text-left">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8 pl-4">
                            <button class="btn btn-primary" (click)="closeDialog()" >Submit</button>  
                        </div>
                    </div>
                </div>
            </div>


        </div>
        

    </mat-card-content>
</mat-card>